module.exports = __webpack_public_path__ + "static/media/Nuvo Tupperware.6eba0495.jpg";